import React, {useContext} from "react"
import {IconButton, Loader} from "rsuite"
import {useRealCostsAssignableCostSourcesQuery} from "../store/costs-api"
import SioIcon from "../../icon/rsuite-icon-font/SioIcon"
import AureliaContext from "../../utilities/aurelia-context"

export default function CostSourceCandidateButtons({destination, onSelect, onCancel}) {
    const {data, isLoading} = useRealCostsAssignableCostSourcesQuery(destination)
    const {currencyValueConverter, i18n} = useContext(AureliaContext)

    if (isLoading) {
        return <Loader/>
    }

    return (
        <div>
            {(data ?? []).map(({identifier, label, calculatedCosts}) => (
                <IconButton
                    key={identifier}
                    size="sm"
                    style={{marginRight: "6px"}}
                    icon={<SioIcon icon="fa fa-link"/>}
                    onClick={() => onSelect(identifier)}
                >
                    {label.objectLabel}
                    {calculatedCosts && ` (${currencyValueConverter.toView(calculatedCosts)})`}
                </IconButton>
            ))}
            <IconButton size="sm" appearance="subtle" onClick={onCancel}>
                {i18n.tr("sio.cancel")}
            </IconButton>
        </div>
    )
}
